import { jsx as n } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import l from "@mui/material/PaginationItem";
import i from "styled-components";
import p from "../../icons/chevron-left.js";
import s from "../../icons/chevron-right.js";
const c = {
  root: "paginationItemRoot",
  disabled: "paginationItemDisabled",
  previousNext: "paginationItemPreviousNext",
  selected: "paginationItemSelected"
}, m = i(s).withConfig({
  displayName: "StyledArrowRight"
})([
  "height:24px;width:24px;padding:5px 4px 5px 5px;box-sizing:border-box;background-color:",
  ";border-radius:100%;color:",
  ";border:1px solid ",
  ";"
], ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.primaryFill), g = i(p).withConfig({
  displayName: "StyledArrowLeft"
})([
  "height:24px;width:24px;padding:5px 5px 5px 4px;box-sizing:border-box;background-color:",
  ";border-radius:100%;color:",
  ";border:1px solid ",
  ";"
], ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.primaryFill), b = i(l).withConfig({
  displayName: "StyledPaginationItem"
})([
  "&&.paginationItemRoot{height:30px;width:30px;border-radius:4px;transition:none;}&&.paginationItemRoot:hover{background-color:",
  ";color:",
  ";}&&.paginationItemRoot.paginationItemPreviousNext:hover{background-color:",
  ";svg{color:",
  ";border:1px solid ",
  ";}}&&.paginationItemRoot.paginationItemPreviousNext:active{background-color:",
  ";svg{color:",
  ";border:1px solid ",
  ";}}&&.paginationItemRoot.Mui-focusVisible{background-color:",
  ";box-shadow:0 0 2px 2px ",
  ";}&&.paginationItemRoot.paginationItemPreviousNext.Mui-focusVisible{background-color:",
  ";box-shadow:none;svg{box-shadow:0 0 2px 2px ",
  ";}}&&.paginationItemSelected{background-color:",
  ";color:",
  ";}&&.paginationItemSelected.Mui-focusVisible{background-color:",
  ";color:",
  ";}&&.paginationItemDisabled{opacity:1;color:",
  ";}&&.paginationItemPreviousNext.paginationItemDisabled{svg{background-color:",
  ";color:",
  ";border:1px solid ",
  ";}}&&.paginationItemSelected.paginationItemDisabled{color:",
  ";background-color:",
  ";}"
], ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primarySelected, ({ theme: o }) => o.primarySelected, ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.primaryDisabled, ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.primaryDisabled), x = /* @__PURE__ */ d(({ classes: o, slots: r, ...a }, e) => {
  const t = {
    next: m,
    previous: g,
    ...r
  };
  return /* @__PURE__ */ n(b, {
    ...a,
    ref: e,
    slots: t,
    classes: {
      ...c,
      ...o
    }
  });
});
x.displayName = "PaginationItem";
export {
  x as default
};
